module.exports = __webpack_public_path__ + "img/ic-diamond-exclamation-orange.4e1900d2.svg";